var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-forward-page",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "88"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#06281d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.798,3.516 L11.892,0.266 C11.615,-0.022 11.299,-0.069 11.021,0.218 C11.021,0.218 11.058,2.408 11.027,2.408 C10.347,2.408 9.944,2.521 9.327,2.722 C8.505,2.993 7.755,3.428 7.119,3.99 C5.843,5.113 5.026,6.392 5.026,8.203 C5.026,9.385 5.549,8.955 5.768,8.542 C6.803,6.597 8.691,5.614 11.049,5.614 C11.079,5.614 11.048,7.76 11.048,7.76 C11.326,8.047 11.676,8.013 11.917,7.807 L15.798,4.557 C16.076,4.268 16.076,3.804 15.798,3.516 L15.798,3.516 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.079 L14,13.062 L0.938,13.062 L0.938,3.937 L6.153,3.937 C6.429,3.625 6.774,3.22 7.376,3.018 L0.00800000003,3.018 L0.00800000003,13.982 L14.97,13.982 L14.97,7.258 L14,8.079 L14,8.079 Z",
    className: "si-glyph-fill"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b49bbe5421f883ee29399f788e02b0c5.svg";
export { ForwardRef as ReactComponent };